/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChipDto } from '../../models/chip-dto';

export interface GetAllChips$Json$Params {
}

export function getAllChips$Json(http: HttpClient, rootUrl: string, params?: GetAllChips$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllChips$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChipDto>>;
    })
  );
}

getAllChips$Json.PATH = '/v1/chips/all';
